import { AdTypes } from '../../DeltaTracking/AdParamBuilder';
import { ISGTrackData } from '../../SDK/SDK';
import Core from '../../Core/Core';
import { DDNAEvents } from '../../DeltaTracking/Tracker';
import { ItemIDs } from '../../Config/Items';
import { Tracking, IAdStages } from './Tracking';

export enum VideoAdReasons {
    PRIZE_WHEEL = 'prize wheel',
    HEART = 'heart',
    COINS = 'coins',
    WIN_PRESENT = 'win present',
}

type IDimMap = { [key in VideoAdReasons | ItemIDs]?: string };

const AdDimensionMap: IDimMap = {
    [VideoAdReasons.PRIZE_WHEEL]: 'WatchAd_PrizeWheel',
    [VideoAdReasons.HEART]: 'VideoAdWatchHeart',
    [VideoAdReasons.COINS]: 'VideoAdWatchGetCoins',
    [VideoAdReasons.WIN_PRESENT]: 'VideoAdWatchPresent',
    [ItemIDs.HINT]: 'VideoAdWatchMagnifier',
    [ItemIDs.HIGHLIGHT]: 'VideoAdWatchFlashlight',
    [ItemIDs.FIRECRACKER]: 'VideoAdWatchFireworks',
    [ItemIDs.MAGNET]: 'VideoAdWatchMagnet',
    [ItemIDs.SHUFFLE]: 'VideoAdWatchShuffle',
    [ItemIDs.TIME]: 'VideoAdWatchClock',
};

export default class AdTracking {
    public static track(
        type: AdTypes,
        deliveryStage: IAdStages,
        placement: string,
        loadtime: number,
        adID: string,
        adAction: string
    ) {
        const trackData = getAdTrackData(type, deliveryStage);
        Tracking.addTrack(trackData);

        if (deliveryStage === IAdStages.FAILED) {
            return;
        } // could add ddna tracking for ad failed

        const ddnaEvent =
            deliveryStage === IAdStages.DELIVERED ? DDNAEvents.AD_SHOW : DDNAEvents.AD_REQUEST;

        if (!Core.delta) {
            return;
        }

        Core.delta.addTrackedEvent(ddnaEvent, {
            adType: type,
            placementID: placement,
            adName: adAction,
            adID,
            adProvider: 'Facebook', // can get from platform name
            adRequestTimeMs: loadtime,
        });
    }

    public static trackAdWatched(id: VideoAdReasons | ItemIDs) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: AdDimensionMap[id],
        });
    }

    public static tooManyAds() {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'VideoAdCannotBeDisplayedFillrate',
        });
    }
}

function getAdTrackData(type: AdTypes, deliveryStage: IAdStages): ISGTrackData {
    const dimension1 = type.charAt(0).toUpperCase() + type.substring(1) + 'Ad' + deliveryStage;
    return {
        event: 'Design',
        dimension1,
    };
}
